import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/help.svg";

const HelpIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default HelpIcon;
